import { Injectable } from '@angular/core';
import { Storage, ref, uploadBytesResumable, getDownloadURL } from '@angular/fire/storage'; // Updated import + added functions

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  constructor(private storage: Storage) { } // Updated injected type

  async uploadFile(file: File, filePath: string): Promise<string> {
    const storageRef = ref(this.storage, filePath); // Use ref function
    const uploadTask = uploadBytesResumable(storageRef, file, { contentType: file.type }); // Use uploadBytesResumable

    // Wait for the upload to complete
    await uploadTask;

    // Get the download URL
    const url = await getDownloadURL(storageRef); // Use getDownloadURL function
    return url;
  }
}